import { useDictionaryContext } from 'application/contexts/DictionaryContext';
import { usePageContext } from 'application/contexts/PageContext';
import { Breadcrumb } from 'designsystem/components/1-atoms/Breadcrumb';
import { LinkFeature } from 'features/Modules/Link';
import { ExcludedFromCludo } from 'helpers/ExcludedFromCludo';

export const BreadcrumbFeature: React.FC = () => {
	const pageContext = usePageContext();
	const { breadcrumb } = pageContext ?? {};
	const dictionary = useDictionaryContext();

	const stripTitle = (index: number, title: string) => {
		const breadcrumbCount = breadcrumb?.length;
		const fullWords = [0, 1, breadcrumbCount - 1];

		// first, second and last item
		// return full title
		if (fullWords.includes(index)) {
			return title;
		}

		// last item minus 1
		// return first three words
		if (index === breadcrumbCount - 2) {
			let regex = /^([\w-]+[^\w\r\n-]+){2}[\w-]+/g;

			const numberOfWords = title.split(' ').length;
			if (numberOfWords === 2) {
				regex = /^([\w-]+[^\w\r\n-]+){1}[\w-]+/g;
			} else if (numberOfWords === 1) {
				return title;
			}

			const found = title.match(regex);
			if (found !== null && found[0].length < title.length) {
				return found[0] + '...';
			} else if (found !== null) {
				return title;
			}
		}

		// rest of items
		// return first five characters
		if (title.length > 6) {
			return title.substring(0, 5).trim() + '...';
		}

		return title;
	};

	return breadcrumb?.length > 0 ? (
		<ExcludedFromCludo>
			<Breadcrumb
				className="rs_skip"
				breadcrumbItems={breadcrumb?.map((item, index) => {
					const displayTitle = stripTitle(index, item.title);
					return <LinkFeature key={index} url={item.url} title={displayTitle} />;
				})}
				label={dictionary.getLabel('BreadcrumbNavigation')}
			/>
		</ExcludedFromCludo>
	) : null;
};
